import React, { useRef } from "react";
import { Box } from "@material-ui/core";
import Iframe from "react-iframe";
import { useAnnotationPainter, useAnnotationsHandler } from "pages/MaterialSpecs/hooks";
import { DrawLayer } from "react-shape-editor";
import { HtmlShapeEditor } from "./HtmlShapeEditor";

interface HtmlPreviewProps {
    path: string;
}

export const HtmlPreview = ({ path }: HtmlPreviewProps) => {
    const { showAnnotations } = useAnnotationsHandler();
    const { drawHandler, shapes, addShapeHandler } = useAnnotationPainter();
    const container = useRef<HTMLDivElement>(null);

    return (
        <Box display="flex" height="94%" width="100%" position="relative" {...{ ref: container }}>
            <Iframe frameBorder={0} url={path} width="100%" height="100%" position="relative" />
            {showAnnotations && (
                <HtmlShapeEditor
                    vectorWidth={container?.current?.offsetWidth || 0}
                    vectorHeight={container?.current?.offsetHeight || 0}
                    scale={1}>
                    <DrawLayer
                        onDrawStart={({ startCorner }) => drawHandler(startCorner)}
                        onAddShape={addShapeHandler}
                    />
                    {shapes}
                </HtmlShapeEditor>
            )}
        </Box>
    );
};
